import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "app-droneviewer" }
const _hoisted_2 = ["src"]

import ViewButtons from '@/components/general/ViewButtons/ViewButtons.vue'
import { computed, watch, ref } from 'vue'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'DroneviewerView',
  setup(__props) {

const store = useStore()
const iframeSource = ref(null)
const isDroneviewShowing = computed(() => store.getters['isDroneviewShowing'])
const currentDroneviewLinkId = computed(() => store.state.currentDroneviewLinkId)
const selectedRealEstate = computed(() => store.state.mapview.selectedRealEstate)

watch(
  () => isDroneviewShowing.value,
  (newValue) => {
    if (newValue === true) {
      if (
        selectedRealEstate.value.droneviewLinks &&
        selectedRealEstate.value.droneviewLinks.length
      ) {
        iframeSource.value =
          selectedRealEstate.value.droneviewLinks[currentDroneviewLinkId.value].link
      } else {
        iframeSource.value = null
      }
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (iframeSource.value)
      ? (_openBlock(), _createElementBlock("iframe", {
          key: 0,
          id: "droneviewer-iframe",
          src: iframeSource.value,
          class: "app-droneviewer__iframe"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (isDroneviewShowing.value)
      ? (_openBlock(), _createBlock(ViewButtons, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})